import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const WebPushSendSkip = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M14.8125 20.4375H9.1875L9.75 18.1875H14.25L14.8125 20.4375Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 20.4375H16.5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5625 15.1875H20.4375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4375 13.6875V15.9375C20.4375 16.5342 20.2004 17.1065 19.7785 17.5285C19.3565 17.9504 18.7842 18.1875 18.1875 18.1875H5.8125C5.21576 18.1875 4.64347 17.9504 4.22151 17.5285C3.79955 17.1065 3.5625 16.5342 3.5625 15.9375V8.0625C3.5625 7.46576 3.79955 6.89347 4.22151 6.47151C4.64347 6.04955 5.21576 5.8125 5.8125 5.8125H9.1875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4375 8.0625C20.4375 8.95252 20.1736 9.82255 19.6791 10.5626C19.1846 11.3026 18.4818 11.8794 17.6596 12.22C16.8373 12.5606 15.9325 12.6497 15.0596 12.476C14.1867 12.3024 13.3849 11.8738 12.7555 11.2445C12.1262 10.6151 11.6976 9.81332 11.524 8.94041C11.3503 8.06749 11.4394 7.16269 11.78 6.34042C12.1206 5.51816 12.6974 4.81535 13.4374 4.32089C14.1775 3.82642 15.0475 3.5625 15.9375 3.5625C17.131 3.5625 18.2756 4.03661 19.1195 4.88052C19.9634 5.72443 20.4375 6.86903 20.4375 8.0625Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5274 6.47266L14.3474 9.65266"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5274 9.65266L14.3474 6.47266"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
